import * as apiService from './apiService'
import { DeviceType } from '@/src/types'

export async function userSignIn(payload: object, deviceType: DeviceType) {
    if (typeof window !== 'undefined') {
        const URL = `/v2/signin`
        const requestHeaders = { 'x-ct-sourcetype': 'web' }

        return apiService.request(URL, payload, deviceType, 'post', {
            requestHeaders,
            skipErrorHandling: true
        })
    }
}

export async function userResetPassword(email: string, deviceType: DeviceType) {
    const URL = `/accounts-api/v2/user/resetPassword?email=${email}`
    return apiService.request(URL, {}, deviceType, 'post', {
        skipErrorHandling: true
    })
}

export async function getUserByEmailId(email: string, deviceType: DeviceType) {
    const domain = window.location.origin
    const URL = `/accounts-api/people/v2/fetch?domain=${domain}&emailId=${email}`
    return apiService.get(URL, deviceType, { skipErrorHandling: true })
}

export async function userSignUp(payload: object, deviceType: DeviceType) {
    const URL = `/accounts-api/user/v2/register`
    const requestHeaders = {
        'x-ct-caller-app': 'web'
    }

    return apiService.request(URL, payload, deviceType, 'post', {
        requestHeaders,
        skipErrorHandling: true
    })
}

export async function userSignOut(
    brand: 'cleartrip' | 'flyin',
    deviceType: DeviceType
) {
    const URL = `/flight/search/v2/logout`
    const requestHeaders = { 'x-ct-sourcetype': 'web' }

    return apiService.request(URL, { brand }, deviceType, 'post', {
        requestHeaders,
        skipErrorHandling: true
    })
}
